import { render, staticRenderFns } from "./PenaltyPolicy.vue?vue&type=template&id=55270e74"
import script from "./PenaltyPolicy.vue?vue&type=script&lang=js"
export * from "./PenaltyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports